import React, { useEffect, useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { useGetTelephonySettingsQuery, useUpdateMachineDetectionMutation } from "@/store/rest_api";
import { apiErrorMessage } from "@/util/apiError";

export default function VoicemailDetectionCard() {
  const { data: settings, isLoading } = useGetTelephonySettingsQuery();
  const [updateMachineDetection, { isLoading: isSaving }] = useUpdateMachineDetectionMutation();
  const [enabled, setEnabled] = useState(false);

  async function handleToggle(next: boolean) {
    setEnabled(next);
    try {
      await updateMachineDetection({ enabled: next }).unwrap();
      toast.success("Setting updated");
    } catch (error: unknown) {
      setEnabled(!next);
      toast.error(apiErrorMessage(error, "Failed to update setting"));
    }
  }

  useEffect(() => {
    if (settings) {
      setEnabled(settings.machineDetectionEnabled);
    }
  }, [settings]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Voicemail detection</CardTitle>
        <CardDescription>Know whether a person or a voicemail answered your outbound calls.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-row items-start justify-between rounded-lg border p-4">
          <div className="space-y-1 pr-4">
            <p className="text-base font-medium">Detect voicemails on outbound calls</p>
            <p className="text-sm text-muted-foreground">
              When an outbound call is answered, detect whether a person or a voicemail picked up and label the call
              accordingly. Your organization is charged $0.01 per answered call. Power dialer campaigns have their own
              voicemail detection setting and are not affected by this switch.
            </p>
          </div>
          <Switch checked={enabled} disabled={isLoading || isSaving} onCheckedChange={handleToggle} />
        </div>
      </CardContent>
    </Card>
  );
}
